import { computed } from "vue";
import type { ViewContext } from "./context.types.ts";
import { GuiElementTypes } from "./context.types.ts";
import { useContextElements } from "./context-elements.ts";
import { NavItem } from "@/shell/pages/side-navigation/composables/nav-items.ts";

export const useContextNavigation = (props: ViewContext) => {
    const MAX_ITEMS = 4;
    const { elements } = useContextElements(GuiElementTypes.buttons, props);

    const contextNavItems = computed<NavItem[]>(() => {
        return elements.value.slice(0, MAX_ITEMS).map(({ symbol, label, url, disabled, tooltip, openInCurrentTab }) => {
            return {
                icon: `fa-regular ${symbol}`,
                visible: true,
                selected: false,
                title: { __type: "static", text: label },
                //will be calculated later
                index: 0,
                externalLink: url,
                target: openInCurrentTab ? "_self" : "_blank",
                tooltip,
                disabled,
            };
        });
    });

    return { contextNavItems };
};
